  <template>
  <div v-role="'func'">
   <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
  <v-data-table
    :headers="headers"
    :items="desserts"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
         <v-chip
            class="ma-4"
            color="primary"
            outlined
            pill
          >
            Painel de Usuários : Funcionário
            <v-icon right>lock</v-icon>
          </v-chip>

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="initialize(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col v-if="false" cols="12" sm="12" md="6">
                      <v-text-field

                        v-model="editedItem.idFuncionario"
                        label="cod"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                        <v-text-field

                        v-model="editedItem.nomeUsuario"
                        label="Nome"
                        :disabled=true
                        :rules="ruleNome"
                      ></v-text-field>

                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.username"
                        label="Email"
                        :rules="ruleEmailRequired"
                      ></v-text-field>

                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                        <v-select v-if="role === 'ADM'"
                                  :items="rolesADM"
                                  :disabled="disativa"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_ADM'"
                                  :items="rolesDir"
                                  :disabled="disativa"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_FUNC'"
                                  :items="rolesFun"
                                  :disabled="disativa"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_PED'"
                                  :items="rolesPed"
                                  :disabled="disativa"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_PWR'"
                                  :items="rolesPWR"
                                  :disabled="disativa"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  dense
                        ></v-select>

                    </v-col>

                     <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.passwordnew"
                         :rules="obrigqtorioRules"
                        label="Password"
                      ></v-text-field>
                    </v-col>

 <v-col cols="12" sm="12" md="6">
            <v-switch  v-if="editedItem.enable" v-model="editedItem.enable"   label="Activa"></v-switch>
            <v-switch  v-if="!editedItem.enable"  v-model="editedItem.enable"   label="Inactiva"></v-switch>
  </v-col>

                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
  </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
let generator = require('generate-password')
export default {
  data: () => ({

    text: '',
    flag_curso: '',
    formValid: true,
    rolesFun: [ 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF' ],
    rolesPed: [ 'ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF'],
    rolesDir: ['ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF', 'ROLE_PWR'],
    rolesPWR: ['ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF', 'ROLE_PWR'],
    rolesADM: ['ROLE_ADM', 'ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF', 'ROLE_PWR'],
    search: '',
    disativa: false,
    cursos: [],
    isLoading: false,
    funcionarios: [],
    obrigqtorioRules: [
      value => !!value || 'campo obrigatório.'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'Máximo número de carácteres atigidos',
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],

    ruleNome: [
      value => value.length <= 50 || 'Máximo número de carácteres atigidos',
      value => !!value || 'campo obrigatório.'
    ],

    desserts: [],
    dialog: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nomeUsuario'
      },

      { text: 'Cod.', value: 'idPessoa' },
      { text: 'Role', value: 'autorizacoes_nome' },
      { text: 'Nome de Usuario', value: 'username' },

      { text: 'Status', value: 'activo' },
      { text: 'Último login', value: 'data_user' },

      { text: 'Modificado', value: 'data_func' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idFuncionario: '',
      idPessoa: '', // bi
      email: '',
      nomeUsuario: '',
      autorizacoes_nome: '',
      enable: false,
      idusuario_autorizacao: '',
      newpassword: '',
      professor: 0,
      pkUsuario: 0,
      passwordnew: ''
    },
    defaultItem: {
      idFuncionario: '',
      idPessoa: '', // bi
      email: '',
      nomeUsuario: '',
      autorizacoes_nome: '',
      enable: false,
      idusuario_autorizacao: '',
      newpassword: '',
      professor: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Funcionário' : 'Editar'
    },

    role () {
      return ls.get('role')
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
    this.iniprofessores()
  },

  methods: {
    passwordgenerator () {
      let generator = require('generate-password')

      return generator.generate({ length: 4, numbers: true })
    },

    async initialize (search) {
      this.isLoading = true
      try {
        if (!search) {
          var payload = '{"find":"all" , "role":"F"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }

        this.desserts = await axios
          .get('/usuarioFindAll/' + payload)
          .then(res => res.data)
        this.FiltraUsuarios_por_Role()
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.newpassword = this.passwordgenerator()
      this.dialog = true
    },

    async Teste () {
      console.log(this.editedItem.professor)
    },

    FiltraUsuarios_por_Role () {
      if (ls.get('role') === 'ROLE_FUNC') {
        this.disativa = true
        this.desserts = this.desserts.filter(t => t.autorizacoes_nome === 'ROLE_FUNC' || t.autorizacoes_nome === 'ROLE_PROF' || t.autorizacoes_nome === 'ROLE_EST')
      } else
      if (ls.get('role') === 'ROLE_PED') {
        this.disativa = false
        this.desserts = this.desserts.filter(t => t.autorizacoes_nome !== 'ROLE_ADMIN')
      }
    },

    deleteItem (item) {
      const index = this.desserts.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1)
    },

    async close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async iniprofessores (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.funcionarios = await axios
          .get('/professor2FindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async save () {
      if (this.$refs.form.validate()) {
        const ls = require('local-storage')
        try {
          var params =
         {
           pkUsuario: this.editedItem.pkUsuario,
           email: this.editedItem.username,
           role: this.editedItem.autorizacoes_nome,
           password: this.editedItem.passwordnew,
           enable: (this.editedItem.enable === true) ? 1 : 0

         }
        } catch (error) {

        }
        try {
          let cor_mensagem = 'msgError'
          let msg = await axios
            .post('/UsuarioInsertOrUpdate', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.dialog = false
          // Verificação da mensagem de erro ou sucesso
          if (msg.length) {
            this.text = 'Ocorreu um erro ao tentar efectuar a operação.'
            cor_mensagem = 'msgError'
          } else {
            this.text = 'Operação efectuada com sucesso.'
            cor_mensagem = 'msgSucess'
            this.initialize()
          }
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: cor_mensagem,
            timeout: 4000
          })
        } catch (error) {
          console.log('eroooo: ' + error)
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        }
      }
    }
  }
}
</script>
